import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col } from 'react-bootstrap';
import ReactTooltip from 'react-tooltip';
import { Translate } from 'react-redux-i18n';

import GenericProductSuggest from '../../../../containers/Common/GenericProductSuggest';
import TypeRadios from '../../../../containers/Common/TypeRadios';

const propTypes = {
  methodSelected: PropTypes.string,
  productSearchTypeA: PropTypes.string,
  suggestValueA: PropTypes.string,
  selectedProductA: PropTypes.shape({
    inStock: PropTypes.number,
    purchased: PropTypes.number,
    presale: PropTypes.number,
    net_weight: PropTypes.number,
    ship_weight: PropTypes.number,
    PriceLv1: PropTypes.number,
    PriceLv2: PropTypes.number,
    PriceLv3: PropTypes.number,
    PriceLv4: PropTypes.number,
    PriceLv5: PropTypes.number,
    currentProdName: PropTypes.string,
    currentProdNum: PropTypes.string,
    currentProductDescription: PropTypes.string,
    currentRefNum: PropTypes.string,
    currentUnitType: PropTypes.string,
    currentPackageSize: PropTypes.string,
    currentProductWeight: PropTypes.number,
    currentProductCRV: PropTypes.number,
    currentProductTaxable: PropTypes.string,
  }),
  productSearchTypeB: PropTypes.string,
  suggestValueB: PropTypes.string,
  selectedProductB: PropTypes.shape({/* same as A */}),
  handleOptionChange: PropTypes.func,
  handleProductSuggestChange: PropTypes.func,
  selectInventoryInfo: PropTypes.func,
  handleClearButtonClick: PropTypes.func,
  handleDuplicateProductAClick: PropTypes.func,
};

const defaultProps = {
  methodSelected: '',
  productSearchTypeA: '',
  suggestValueA: '',
  selectedProductA: {},
  productSearchTypeB: '',
  suggestValueB: '',
  selectedProductB: {},
  handleOptionChange: () => {},
  handleProductSuggestChange: () => {},
  selectInventoryInfo: () => {},
  handleClearButtonClick: () => {},
  handleDuplicateProductAClick: () => {},
};

const BuyAGetBProductSearches = ({
  methodSelected,
  productSearchTypeA,
  productSearchTypeB,
  selectedProductA,
  selectedProductB,
  suggestValueA,
  suggestValueB,
  handleOptionChange,
  handleProductSuggestChange,
  handleClearButtonClick,
  selectInventoryInfo,
  handleDuplicateProductAClick,
}) => {
  const detailsStringA = `${selectedProductA.currentProdNum} | ${selectedProductA.currentRefNum} | ${selectedProductA.currentProdName} | ${selectedProductA.currentProductDescription}`;
  const detailsStringB = `${selectedProductB.currentProdNum} | ${selectedProductB.currentRefNum} | ${selectedProductB.currentProdName} | ${selectedProductB.currentProductDescription}`;
  return (
    <div className="buy-a-get-b-product-section">
      <div>
        <label htmlFor="productSearchA"><Translate value="product_a" />:</label>
        <Col xs={12}>
          <TypeRadios
            value={productSearchTypeA}
            handleOptionChange={(event) => {
              handleOptionChange(event, 'productSearchTypeA');
            }}
          />
        </Col>
        <Col xs={12} id="promotions-auto-suggest">
          {
            (!selectedProductA || !selectedProductA.currentProdNum)
              ? (
                <div className="control-dropdown">
                  <GenericProductSuggest
                    value={suggestValueA}
                    onChange={(e, { newValue }) => handleProductSuggestChange(e, newValue, 'suggestValueA')}
                    SearchType={productSearchTypeA}
                    fetchOrdersByProduct={(productNum, selectedInventoryRow) => {
                      selectInventoryInfo(productNum, selectedInventoryRow, 'selectedProductA');
                    }}
                  />
                </div>
              ) : (
                <div id="suggestion-box">
                  <ReactTooltip id="product-a-tool-tip" place="top" type="dark" effect="solid">
                    <div className="product-a-tool-tips">
                      <div className="flex-row">
                        <label htmlFor="unit-type"><Translate value="unit_type" />:</label>
                        <span>{ selectedProductA.currentUnitType }</span>
                      </div>
                      <div className="flex-row">
                        <label htmlFor="package-size"><Translate value="package_size" />:</label>
                        <span>{ selectedProductA.currentPackageSize }</span>
                      </div>
                      <div className="flex-row">
                        <label htmlFor="weight"><Translate value="weight" />:</label>
                        <span>{ selectedProductA.currentProductWeight }</span>
                      </div>
                      <div className="flex-row">
                        <label htmlFor="price"><Translate value="ref_price" />:</label>
                        <span>{ (selectedProductA.currentRefPrice) ? `$${parseFloat(selectedProductA.currentRefPrice).toFixed(2)}` : '' }</span>
                      </div>
                    </div>
                  </ReactTooltip>
                  <span data-tip data-for="product-a-tool-tip" className="detail-string">{ detailsStringA }</span>
                  <button
                    className="invisible-button pull-right"
                    onClick={() => handleClearButtonClick('selectedProductA', 'suggestValueA')}
                  >
                    <em className="fa fa-times" />
                  </button>
                </div>
              )
          }
        </Col>
      </div>
      <div>
        <div className="product-b-label">
          <label htmlFor="productSearchB"><Translate value="product_b" />:</label>
          <Button
            bsStyle="primary"
            className="auto-fill-button"
            onClick={handleDuplicateProductAClick}
          >
            <em className="fa fa-edit" /><Translate value="use_product_a" />
          </Button>
        </div>
        <Col xs={12}>
          <TypeRadios
            value={productSearchTypeB}
            handleOptionChange={(event) => {
              handleOptionChange(event, 'productSearchTypeB');
            }}
          />
        </Col>
        <Col xs={12} id="promotions-auto-suggest">
          {
            (!selectedProductB || !selectedProductB.currentProdNum)
              ? (
                <div className="control-dropdown">
                  <GenericProductSuggest
                    value={suggestValueB}
                    onChange={(e, { newValue }) => handleProductSuggestChange(e, newValue, 'suggestValueB')}
                    SearchType={productSearchTypeB}
                    fetchOrdersByProduct={(productNum, selectedInventoryRow) => {
                      selectInventoryInfo(productNum, selectedInventoryRow, 'selectedProductB');
                    }}
                  />
                </div>
              ) : (
                <div id="suggestion-box">
                  <ReactTooltip id="product-b-tool-tip" place="top" type="dark" effect="solid">
                    <div className="product-b-tool-tips">
                      <div className="flex-row">
                        <label htmlFor="unit-type"><Translate value="unit_type" />:</label>
                        <span>{selectedProductB.currentUnitType}</span>
                      </div>
                      <div className="flex-row">
                        <label htmlFor="package-size"><Translate value="package_size" />:</label>
                        <span>{selectedProductB.currentPackageSize}</span>
                      </div>
                      <div className="flex-row">
                        <label htmlFor="weight"><Translate value="weight" />:</label>
                        <span>{selectedProductB.currentProductWeight}</span>
                      </div>
                      <div className="flex-row">
                        <label htmlFor="price"><Translate value="ref_price" />:</label>
                        <span>{(selectedProductB.currentRefPrice) ? `$${parseFloat(selectedProductB.currentRefPrice).toFixed(2)}` : ''}</span>
                      </div>
                    </div>
                  </ReactTooltip>
                  <span data-tip data-for="product-b-tool-tip" className="detail-string">{ detailsStringB }</span>
                  <button
                    className="invisible-button pull-right"
                    onClick={() => handleClearButtonClick('selectedProductB', 'suggestValueB')}
                  >
                    <em className="fa fa-times" />
                  </button>
                </div>
              )
          }
        </Col>
      </div>
    </div>
  );
};

BuyAGetBProductSearches.propTypes = propTypes;
BuyAGetBProductSearches.defaultProps = defaultProps;

export default BuyAGetBProductSearches;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/PromotionsPage/components/BuyAGetBProductSearches.jsx